import React, { Component } from 'react'
import { WeeklyAvailabilityScheduleComponent } from '../../../../weeklyAvailability';
import { MuiGrid, MuiButton, MuiToolTip, MuiTypography } from '../../../../../ui/MaterialUIComponents';
import lodashUtil from 'lodash';
import { DialogComponentUtil } from '..';
import * as StringReplacer from '../../../../../../i18n/StringReplacer';
import theme from '../../../../../../assests/theme'
import spinner from "../../../../../ui/icons/spinner.gif";
export class PreferredPeriodComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isScheduleOpen: true,
			isPreferredPeriod: true
		}
	}

	render() {
		const { i18n } = this.props
		return (
			<React.Fragment>
				<MuiGrid container>
					<MuiToolTip
						placement="top-start"
						title={StringReplacer.getFormatedMessage(i18n.preferredPeriod.heading,
							{
								Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
								Grades: DialogComponentUtil.getToolTipString(this.props),
							})
						} >
						<MuiTypography style={theme.typography.h6} gutterBottom>
							{StringReplacer.getFormatedMessage(i18n.preferredPeriod.heading,
								{
									Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
									Grades: DialogComponentUtil.getGradeForTemplate(this.props),
								})
							}
						</MuiTypography>
					</MuiToolTip>
				</MuiGrid>
				<MuiGrid container xs={12}>
					{this.props.isScheduleOpen == true && (
						<WeeklyAvailabilityScheduleComponent
							{...this.state}
							{...this.props}
							renderAvailabilityScheduleRow={this.props.renderAvailabilityScheduleRow}
							removeWeeklyAvailabilitySchedule={this.props.removeWeeklyAvailabilitySchedule}
						/>
					)}
				</MuiGrid>
				<MuiGrid container xs={12} justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>

					<MuiGrid item style={{ marginRight: "10px" }}>
						<MuiButton style={theme.secondaryButtonStyle} onClick={this.props.handleCloseForDialog}>
							{i18n.commonTexts.cancel}
						</MuiButton>
					</MuiGrid>

					<MuiGrid item>
						{this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
							<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={this.props.onClickOfSave}>
								{i18n.commonTexts.apply}
							</MuiButton>}
					</MuiGrid>
				</MuiGrid>
			</React.Fragment>
		)
	}
}

export default PreferredPeriodComponent
